import React from 'react';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useDispatch } from 'react-redux';
import { showToast } from '@/features/toast/toastSlice';

/**
 * Wraps a record's chip (or other element) in a tooltip showing its doc id, with a button
 * that copies it, e.g. for the user import spreadsheet. The tooltip stays open while the
 * pointer is over it, so the id can also be selected.
 */
export const CopyIdTooltip = ({ id, children }) => {
	const dispatch = useDispatch();

	const handleCopy = async (event) => {
		// The tooltip renders in a portal, but React still bubbles the click to the chip's
		// row or cell, which may open something
		event.stopPropagation();
		try {
			await navigator.clipboard.writeText(id);
			dispatch(showToast({ message: 'Id copied', success: true, duration: 2000 }));
		} catch {
			dispatch(showToast({ message: 'Couldn\'t copy the id', error: true }));
		}
	};

	return (
		<Tooltip
			title={
				<Stack direction='row' spacing={0.5} alignItems='center'>
					<Typography variant='caption' sx={{ userSelect: 'all' }}>
						{id}
					</Typography>
					<IconButton size='small' color='inherit' onClick={handleCopy} aria-label='Copy id'>
						<ContentCopyIcon sx={{ fontSize: 14 }} />
					</IconButton>
				</Stack>
			}
		>
			{children}
		</Tooltip>
	);
};
